import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CloseIcon, CheckIcon } from 'components/lib/icons'
import { colors } from 'config/ui'
import {
  Wrapper,
  Label,
  InputWrapper,
  StyledInput,
  Helper
} from './Input.styles'

class Input extends Component {
  state = {
    focused: false
  }

  toggleFocus = () => {
    this.setState(prevState => ({
      focused: !prevState.focused
    }))
  }

  render() {
    const {
      id,
      name,
      label,
      placeholder,
      helper,
      style,
      width,
      height,
      disabled,
      error,
      success,
      transparent,
      labelColor,
      labelStyle,
      onKeyUp,
      children,
      className,
      defaultValue,
      secondary,
      fluid,
      inputProps,
      ...rest
    } = this.props
    const { inputRef } = this.props
    const { focused } = this.state
    const showPlaceholder = !!((transparent && focused) || !transparent)

    return (
      <Wrapper
        width={width}
        style={style}
        fluid={fluid}
        secondary={secondary}
        className={className}
      >
        {label && (
          <Label
            disabled={disabled}
            color={labelColor}
            htmlFor={id}
            style={labelStyle}
          >
            {label}
          </Label>
        )}
        <InputWrapper
          width={width}
          height={height}
          fluid={fluid}
          disabled={disabled}
          error={error}
          secondary={secondary}
          success={success}
          focused={focused}
          transparent={transparent}
        >
          <StyledInput
            ref={inputRef || null}
            id={id}
            name={name}
            secondary={secondary}
            defaultValue={defaultValue}
            placeholder={showPlaceholder ? placeholder : undefined}
            width={width}
            height={height}
            disabled={disabled}
            transparent={transparent}
            onFocus={this.toggleFocus}
            onBlur={this.toggleFocus}
            onKeyUp={e => onKeyUp && onKeyUp(e.key)}
            autocapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="off"
            {...inputProps}
            {...rest}
            aria-invalid={error || undefined}
            aria-describedby={helper && id ? `${id}-helper` : undefined}
          />
          {error && (
            <CloseIcon
              style={{ margin: '10px' }}
              color={colors.red}
              data-testid={'error-icon'}
            />
          )}
          {success && (
            <CheckIcon
              style={{ margin: '10px' }}
              color={'#58D68D'}
              data-testid={'success-icon'}
            />
          )}
          {children && children}
        </InputWrapper>
        {helper && (
          <Helper
            id={id ? `${id}-helper` : undefined}
            role={error ? 'alert' : undefined}
          >
            {helper}
          </Helper>
        )}
      </Wrapper>
    )
  }
}

export const inputPropTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  labelColor: PropTypes.string,
  labelStyle: PropTypes.object,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  transparent: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(HTMLInputElement) })
  ]),
  onKeyUp: PropTypes.func,
  defaultValue: PropTypes.string,
  inputProps: PropTypes.object
}

Input.propTypes = inputPropTypes

export default Input
